import { useState, useEffect } from 'react';

const CART_KEY = 'unisyn_cart';

/**
 * Drop-in replacement for useState([]) for cart items.
 * Persists to localStorage so the cart survives page refreshes.
 */
export const useCartStorage = () => {
  const [cartItems, setCartItemsState] = useState(() => {
    try {
      const stored = localStorage.getItem(CART_KEY);
      if (!stored) return [];
      const parsed = JSON.parse(stored);
      return parsed.map(item => ({ ...item, quantity: Number(item.quantity) || 0 }));
    } catch {
      return [];
    }
  });

  const setCartItems = (updater) => {
    setCartItemsState((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      try {
        localStorage.setItem(CART_KEY, JSON.stringify(next));
      } catch {
        // storage quota exceeded — still update in memory
      }
      return next;
    });
  };

  return [cartItems, setCartItems];
};
